import actions from "@/store/modules/clock/actions";
import mutations from "@/store/modules/clock/mutations";
import state from "@/store/modules/clock/state";

export default {
    actions,
    mutations,
    state
}